import {Module} from "vuex";
import {State} from "@/store";
import Vue from "vue";
import {IGlobalConfigAdmin} from "@/models/global-config/GlobalConfigAdminModels";
import {IGlobalConfigShop} from "@/models/global-config/GlobalConfigShopModels";

export interface GlobalConfig {
	modelAdmin: IGlobalConfigAdmin | null;
	modelShop: IGlobalConfigShop | null;
}

const globalConfig: Module<GlobalConfig, State> = {
	namespaced: true,
	state: {
		modelAdmin: null as IGlobalConfigAdmin | null,
		modelShop: null as IGlobalConfigShop | null,
	},
	mutations: {
		setModelAdmin(state: GlobalConfig, model: IGlobalConfigAdmin) {
			state.modelAdmin = model;
		},
		setModelShop(state: GlobalConfig, model: IGlobalConfigShop) {
			state.modelShop = model;
		},
	},
	actions: {
		async reload(context) {
			try {
				const modelAdmin = await Vue.$globalConfigServiceAdmin.globalConfig();
				if (modelAdmin !== null) context.commit('setModelAdmin', modelAdmin);
			} catch (e) {
				console.error('loading global config failed', e);
			}
		},
		async reloadShop(context) {
			try {
				const modelShop = await Vue.$globalConfigServiceShop.globalConfig();
				if (modelShop !== null) context.commit('setModelShop', modelShop);
			} catch (e) {
				console.error('loading shop global config failed', e);
			}
		}
	},
};

export default globalConfig;
